export default __webpack_public_path__ + "029e165f50c380eedd2b7cf34f23f25e.png";